export default "__VITE_ASSET__qLjIQjbx__"